import styled from 'styled-components/macro';

import { distances } from '../../styles/constants';

const LinkGroup = styled.section`
    margin-bottom: ${distances.small};

    &:first-child {
        margin-top: ${distances.small};
    }

    @media (max-width: 768px) {
        display: contents;
        margin-top: 0;
        margin-bottom: 0;
        position: relative;
        &:first-child {
            margin-top: 0;
        }
    }
`;

export default LinkGroup;
